<template>
  <div id="visita-registra-aplicacion">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Datos para Agendar y Registrar Visita</v-toolbar-title
              >
            </v-toolbar>
            <v-form>
              <data-visita-crear
                v-if="this.tipeView == 'crear'"
                :tipeView="tipeView"
              ></data-visita-crear>
              <data-visita v-else :id="id" :tipeView="tipeView"></data-visita>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import DataVisita from "@/modules/aplicacion/views/visita/VisitaData.vue";
import DataVisitaCrear from "@/modules/aplicacion/views/visita/VisitaDataCrear.vue";

import axios from "axios";

export default {
  name: "visita-registra-aplicacion",
  components: {
    DataVisita,
    DataVisitaCrear,
  },
  props: {},

  data: () => ({
    documentoId: "",
    id: "",
    tipeView: "",
  }),

  computed: {},
  mounted() {},
  created() {
    this.id = this.$route.params.id;
    this.tipeView = this.$route.params.tipeView;
    this.tab = this.$store.getters.subTabSelectedStored;
  },

  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
